import { Button, ButtonProps } from '@chakra-ui/react';
import React from 'react';

interface CustomButtonWithIconProps extends ButtonProps {}

const TransparentBackgroundButton: React.FC<
	CustomButtonWithIconProps
> = props => {
	const { children, ...rest } = props;
	return (
		<>
			<Button
				bg="transparent"
				color="#222"
				alignContent="center"
				position="relative"
				_active={{ transform: 'scale(0.95)', background: 'transparent' }}
				_hover={{ background: 'transparent' }}
				{...rest}>
				{props.children}
			</Button>
		</>
	);
};

export default TransparentBackgroundButton;
